/* eslint-disable */
import React from 'react';
import { useQuery } from '@apollo/client';
import useParamsRouter from '../../../hooks/useParamsRouter';
import BreadCrumb from '../../BreadCrumb';
import { GetCredentialAndGrouping } from '../gql/sharedQueries';

export default function BreadCrumbFormList() {
  const { credentialTypeIdInt, groupingIdInt } = useParamsRouter();
  const { data, loading } = useQuery(GetCredentialAndGrouping, {
    variables: { credentialTypeIdInt, groupingIdInt },
  });
  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div className="col-10 align-self-end">
      <BreadCrumb
        path={[
          { label: data.credentialType.displayName || ' ', link: `/credential-type/${credentialTypeIdInt}/groupings/` },
          { label: data.grouping.name.toUpperCase() || '' },
        ]}
      />
      <h1 className="h4 m-0 text-uppercase">{data.grouping.name.toUpperCase() || ''}</h1>
    </div>
  );
}
